import React, { useEffect } from 'react';
import {
  Appbar,
  BottomNavigator,
  LoginAlert,
  Overlay,
  GameAlert,
} from '@components';
import styled from 'styled-components';
import HomeRoutes from './HomeRoutes';
import { useLocation } from 'react-router-dom';
import { PUBLIC_ROUTE } from '@router/route.constants';
import { NoInternet } from '@pages';
import { setHasWithdrawAccount } from "@redux/app/appSlice";
import { api } from "@api";
import { useDispatch } from "react-redux";

const Container = styled.div`
min-height: 100vh;
position: relative;
`;

const Home = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

    const getUserPayments = () => {
      api
        .getUserPayments()
        .then(({ user_payments }) => {
          dispatch(setHasWithdrawAccount(user_payments.length > 0));
        })
        .catch(() => { });
    };

    useEffect(() => {
    getUserPayments();
  }, []);

    if (!navigator.onLine) {
    return <NoInternet />
  }

  return (
    <>
      <Container>
        {pathname !== `/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.MESSAGE}` && < Appbar />}
        <HomeRoutes />
        <BottomNavigator />
      </Container>
      <LoginAlert />
      <Overlay />
      <GameAlert />
    </>
  );
}

export default Home;